import { Injectable } from "@angular/core"
import { environment } from "src/environments/environment"
import { HttpClient, HttpParams } from "@angular/common/http"
import { Observable } from "rxjs"
import { ITableResponse } from "../models/contracts/table"
import { Permission } from "../models/permission/permission"
import { PermissionPostRequest } from "../models/permission/permission-post-request"
import { PermissionGetRequest } from "../models/permission/permission-get-request"
import { PermissionPutRequest } from "../models/permission/permission-put-request"
import { GroupStatusType } from "src/app/shared/enum/groupStatusType"

@Injectable({
  providedIn: "root",
})
export class PermissionService {
  private post_permission_url: string
  private get_permission_id_url: string
  private get_permission_url: string
  private get_all_permission_url: string
  private put_permission_url: string

  constructor(private httpClient: HttpClient) {
    this.buildUrls(environment.endpointPermission.url)
  }

  private buildUrls(permissionApiUrl: string) {
    this.get_permission_id_url =
      permissionApiUrl + environment.endpointPermission.routes.get_permission_id
    this.get_permission_url =
      permissionApiUrl +
      environment.endpointPermission.routes.get_permission_paginate
    this.post_permission_url =
      permissionApiUrl + environment.endpointPermission.routes.post_permission
    this.put_permission_url =
      permissionApiUrl + environment.endpointPermission.routes.put_permission
    this.get_all_permission_url =
      permissionApiUrl +
      environment.endpointPermission.routes.get_all_permission_paginate
  }

  savePermission(data: PermissionPostRequest): Observable<any> {
    if (typeof data.status === "boolean") {
      data.status = data.status
        ? GroupStatusType.Open
        : GroupStatusType.OutOfService
    }
    return this.httpClient.post(this.post_permission_url, data)
  }

  getPermissionPaginate(
    filters: PermissionGetRequest
  ): Observable<ITableResponse<Permission>> {
    let params = new HttpParams()
    if (filters) {
      if (filters.permissionName)
        params = params.set("permissionName", filters.permissionName)
      if (filters.permissionCode)
        params = params.set("permissionCode", filters.permissionCode)
      if (filters.schoolID) params = params.set("schoolID", filters.schoolID)
      if (filters.status !== undefined && filters.status !== null)
        params = params.set("status", String(filters.status))
      params = params.set("IsDesc", String(filters.isDesc))
      if (filters.orderByFilter)
        params = params.set("orderByFilter", filters.orderByFilter)
      params = params.set("askPage", filters.askPage.toString())
      params = params.set("itensPerPage", filters.itensPerPage.toString())
    }

    return this.httpClient.get<ITableResponse<Permission>>(
      this.get_permission_url,
      { params }
    )
  }

  getPermissionById(id: string): Observable<any> {
    return this.httpClient.get(
      this.get_permission_id_url.replace("{permissionId}", id)
    )
  }

  getAllPerrmission(): Observable<any> {
    return this.httpClient.get(this.get_all_permission_url)
  }

  updatePermission(id: string, data: PermissionPutRequest): Observable<any> {
    if (typeof data.status === "boolean") {
      data.status = data.status
        ? GroupStatusType.Open
        : GroupStatusType.OutOfService
    }
    return this.httpClient.put(
      this.put_permission_url.replace("{permissionId}", id),
      data
    )
  }
}
